import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Button, Stack } from '@mui/material';

import { NPIIconButton } from 'src/components/index';

type DeleteModeButtonsProps = {
    isActive: boolean;
    onEnter: () => void;
    onCancel: () => void;
    onConfirm: () => void;
    disableConfirm?: boolean;
};

function DeleteModeButtons({
    isActive,
    onEnter,
    onCancel,
    onConfirm,
    disableConfirm,
}: Readonly<DeleteModeButtonsProps>) {
    if (!isActive) {
        return (
            <Stack direction="row" spacing={1} alignItems={'center'}>
                <NPIIconButton
                    icon={<DeleteOutlineIcon />}
                    onClick={onEnter}
                    data-testid="enter-delete-mode-button"
                />
            </Stack>
        );
    }

    return (
        <Stack direction="row" spacing={1}>
            <Button
                variant="npi-primary"
                disabled={disableConfirm}
                startIcon={<DeleteOutlineIcon />}
                onClick={onConfirm}
                data-testid="confirm-delete-mode-button"
            >
                Delete
            </Button>
            <Button
                variant="npi-teal"
                color="inherit"
                onClick={onCancel}
                data-testid="cancel-delete-mode-button"
            >
                Cancel
            </Button>
        </Stack>
    );
}

export default DeleteModeButtons;
